import { PermissionNode } from "./permission-node.model";

export class PermissionTable {
    levelModulePermissionId: string;
    name: string;
    urlSgc1: string;
    urlSgc2: string;
    redirectToSgc1: boolean;
    level0: boolean | 'indeterminate';
    level1: boolean | 'indeterminate';
    level2: boolean | 'indeterminate';
    level3: boolean | 'indeterminate';
    level4: boolean | 'indeterminate';
    level5: boolean | 'indeterminate';
    level6: boolean | 'indeterminate';
    isEdited: boolean;
    index: number;
    isParent: boolean;
    isExpanded: boolean;
}